import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { FormFields } from '../../form-fields/form-fields.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-campaign-3-search-paniere',
  templateUrl: './campaign-3-search-paniere.component.html',
  styleUrls: ['./campaign-3-search-paniere.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchPaniereComponent implements OnInit {
  
  @Input() paniereList: Array<any> = [];
  
  @Output() paniereListSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() paniereListCancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() productsListSelected: EventEmitter<any> = new EventEmitter<any>();

  
  @ViewChild('new_name_paniere') new_name_paniere: FormFields;
  @ViewChild('new_code_paniere') new_code_paniere: FormFields;
  @ViewChild('new_description_paniere') new_description_paniere: FormFields;

  rowSelected = {identifierField: 'id', arrayValues: []};
  listPaniereSelected: Array<any> = [];
  listProductSelected: Array<any> = [];
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  
  paniereListCopy: Array<any> = [];

  show = {
    tableBasket: false,
    tableProduct: false
  }

  fieldModel = {
    new_name_paniere: null,
    new_description_paniere:null,
    new_code_paniere:null
  }
  postPayload = {
    name: null,
    description: null,
    code: null,
    productItems: [] // Inizializzato come array vuoto
  }
  

  switch = {
    seleziona: true,
    importa: false
  }

  choiceCode: string = "LIST";
  
  constructor(
    private srvCampaign3: Campaign3Service,
    private srvNotify: MessageService,
    private translate: TranslateService
  ) {}
  ngOnInit() {

    if(this.paniereList){
      for(let pan of this.paniereList){
        if(pan.rowSelected == true){
          this.listPaniereSelected.push(Object.assign({},pan));
        }
      }
      this.show.tableBasket = true;
    }


    this.show.tableProduct = true;
    /*
    if(this.productList){
      for(let prod of this.productList){
        if(prod.rowSelected == true){
          this.listProductSelected.push(Object.assign({},prod));
        }
      }
      this.show.tableProduct = true;
    }
    */
  }
  onPaniereSelected(pan: any){
    let indexInSelected = this.listPaniereSelected.findIndex(x=>x.basketId == pan.basketId);
    if(!pan.rowSelected){
      if(indexInSelected>-1) this.listPaniereSelected.splice(indexInSelected,1);
    }
    else if(pan.rowSelected){
      if(indexInSelected==-1) this.listPaniereSelected.push(pan);
    }
  }
  onProductsSelected(prod: any){
    let indexInSelected = this.listProductSelected.findIndex(x=>x.id == prod.id);
    if(!prod.rowSelected){
      if(indexInSelected>-1) this.listProductSelected.splice(indexInSelected,1);
    }
    else if(prod.rowSelected){
      if(indexInSelected==-1) this.listProductSelected.push(prod);
    }
  }
/*   aggiungiProducts_old(){
    //validazione
    this.new_name_paniere.performValidation();
   
   

    if(this.new_name_paniere.valid && this.fieldModel.new_name_paniere && this.listProductSelected && this.listProductSelected.length>0){
      var self = this;
      this.srvCampaign3.saveNewBasket(this.fieldModel.new_name_paniere).subscribe(res=>{
        if(res>0){
          let arrayProdId: Array<number> = [];
          for(let prod of this.listProductSelected){
            arrayProdId.push(prod.product_id);
          }
          var self2= self;
          self.srvCampaign3.saveNewBaskerDetails(res,arrayProdId).subscribe(res2=>{
            if(res2 == true){
              self2.productsListSelected.emit(true);
            }
            else{
              self2.productsListSelected.emit(false);
            }
          })

        }
        else{
          self.productsListSelected.emit(false);
        }
      });
    }
    else{
      this.productsListSelected.emit(false);
    }
  }
 */
  //chiarire productListSelected e paniereListSelected
  aggiungiProducts() {
    //validazione
    this.new_name_paniere.performValidation();
    this.new_description_paniere.performValidation();
    this.new_code_paniere.performValidation();

    if (this.fieldModel.new_name_paniere &&
      this.fieldModel.new_description_paniere &&
      this.fieldModel.new_code_paniere &&
      this.listProductSelected &&
      this.listProductSelected.length > 0
    ) {
      //creazione payload
      this.postPayload.name = this.fieldModel.new_name_paniere;
      this.postPayload.description = this.fieldModel.new_description_paniere;
      this.postPayload.code = this.fieldModel.new_code_paniere;
      let arrayProdId: Array<number> = [];
      for (let prod of this.listProductSelected) {
        arrayProdId.push(prod.id);
      }
      this.postPayload.productItems = arrayProdId;

      //procedo al salvataggio
      this.srvCampaign3.saveNewBasket(this.postPayload).subscribe(res => {
      
        if (res && res.id > 0) {
          this.productsListSelected.emit(true);
        }
        else {
          this.productsListSelected.emit(false);
        }
      });
    }
    else {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),  
        detail: this.translate.instant('campaign.fill_all_required_fields'),
        life: 5000
      });
      
     return;
    }
  }
  onClickAggiungiPaniere(){
    if(this.choiceCode == "LIST"){
      if(this.listPaniereSelected && this.listPaniereSelected.length>0){
        this.paniereListSelected.emit(this.listPaniereSelected);
      }
      else{
        this.paniereListSelected.emit(null);
      }
    }
    else if(this.choiceCode == "NEW"){
      if(this.switch.seleziona == true){
        this.aggiungiProducts();
      }
    }
  }
  @ViewChild('productsListPaniereTable') productsListPaniereTable: Campaign3KontableComponent;

  onRefreshTable() {
    var self = this;
    setTimeout(() => {

      self.productsListPaniereTable.refresh();
    }, 100)

  }
  onClickAnnullaPaniere(){
    this.paniereListCancel.emit(true);
  }
  onClickElenco(){
    this.choiceCode = "LIST";
  }
  onClickNuovo(){
    this.choiceCode = "NEW";
  }
  onChangeSwitchSeleziona(){
    this.switch.importa = !this.switch.seleziona;
  }
/*   onChangeSwitchImporta(){
    this.switch.seleziona = !this.switch.importa;
  } */
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-paniere/campaign-3-search-paniere.component.ts